export var FileProviderItemType;
(function (FileProviderItemType) {
    FileProviderItemType[FileProviderItemType["File"] = 0] = "File";
    FileProviderItemType[FileProviderItemType["Folder"] = 1] = "Folder";
})(FileProviderItemType || (FileProviderItemType = {}));
export var ImageLoadState;
(function (ImageLoadState) {
    ImageLoadState[ImageLoadState["NotLoaded"] = 0] = "NotLoaded";
    ImageLoadState[ImageLoadState["Loaded"] = 1] = "Loaded";
    ImageLoadState[ImageLoadState["ErrorLoading"] = 2] = "ErrorLoading";
})(ImageLoadState || (ImageLoadState = {}));
//# sourceMappingURL=FileProviderItemViewState.js.map